import { apiSlice } from '../../app/services/apiSlice';

const PROFILE_URL = 'authentication/user';

export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProfileDetails: builder.query({
      query: () => ({
        url: `${PROFILE_URL}`,
      }),
      providesTags: ['user'],
    }),
    getUserDetails: builder.query({
      query: (params) => ({
        url: `${PROFILE_URL}/me`,
        params: { ...params },
      }),
      keepUnusedDataFor: 0,
      providesTags: ['user'],
    }),
    getUser: builder.mutation({
      query: (params) => ({
        url: `${PROFILE_URL}/me`,
        params: { ...params },
      }),
      providesTags: ['user'],
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `${PROFILE_URL}`,
        method: 'PUT',
        body: { ...data },
      }),
      invalidatesTags: ['user'],
    }),
  }),
});

export const {
  useGetProfileDetailsQuery,
  useGetUserDetailsQuery,
  useGetUserMutation,
  useUpdateProfileMutation,
} = profileApiSlice;
